import { AfterContentInit, Component, ElementRef, inject, Input, ViewChild, ChangeDetectionStrategy, input } from "@angular/core";
import { EnergyConsult } from "../../../classes/flow/request/EnergyConsult";
import { ApplicationService } from "../../../services/application.service";
import { AuthService } from "../../../services/auth.service";
import { NgClass } from "@angular/common";
import { RouterLink } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { EnergyConsultComponent } from "../../energy-consult/energy-consult.component";
import { TranslatePipe } from "@ngx-translate/core";
import { RequestState } from "src/app/classes/flow/request/RequestStates";
import { Coach } from "src/app/classes/flow/session/impl/Coach";

@Component({
  selector: "app-consult-grid-view",
  templateUrl: "./consult-grid-view.component.html",
  styleUrls: ["./consult-grid-view.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, RouterLink, MatIcon, EnergyConsultComponent, TranslatePipe],
})
export class ConsultGridViewComponent implements AfterContentInit {
  readonly applicationService = inject(ApplicationService);

  private auth = inject(AuthService);

  @Input("filteredRequests") set filteredRequestsSetter(filteredRequests: EnergyConsult[]) {
    this.filteredRequests = filteredRequests;
    if (this.scrollContainer) this.scrollContainer.nativeElement.scrollTo({ behavior: "smooth", top: 0, left: 0 }); //smooth
    this.shownRequestsStepper.stepsCounter = 1;
    this.showRequests = this.filteredRequests.slice(0, this.shownRequestsStepper.stepSize * this.shownRequestsStepper.stepsCounter);
  }

  @ViewChild("scrollContainer") scrollContainer?: ElementRef;

  filteredRequests: EnergyConsult[] = [];

  public showRequests: EnergyConsult[] = [];

  public shownRequestsStepper = {
    stepSize: 18,
    stepsCounter: 1,
  };
  public submitRequest = false;

  public requestStates = input.required<RequestState[]>();
  public coaches = input.required<Coach[]>();

  ngAfterContentInit(): void {
    this.submitRequest = this.auth.roleName === "resident";
    return;
  }

  public showMoreConsults(event: Event) {
    const div = event.target as HTMLDivElement;

    const h = ((div.scrollTop + div.offsetHeight) / div.scrollHeight) * 100;

    if (h > 90) {
      this.shownRequestsStepper.stepsCounter++;
      this.showRequests = this.filteredRequests.slice(0, this.shownRequestsStepper.stepSize * this.shownRequestsStepper.stepsCounter);
    }
  }

  public resetAfterSort() {
    this.showRequests = this.filteredRequests.slice(0, this.shownRequestsStepper.stepSize * this.shownRequestsStepper.stepsCounter);
  }

  public trackByECId(index: number, ec: EnergyConsult) {
    return ec.id;
  }
}
